import React from 'react'
import { Button, Span } from '../../main'
import { IDownload } from '../types'

function Download({
  downloadCSV,
  downloadLoading,
  downloadLabel,
  downloadDisabled = downloadLoading,
  downloadTitle = downloadLabel
}: IDownload) {
  if (!downloadCSV) {
    return null
  }
  const defaultLabel = 'Download'
  return (
    <span title={downloadTitle}>
      <Button
        data-testid={`download`}
        disabled={downloadDisabled}
        isLoading={downloadLoading}
        style={{ marginLeft: 6 }}
        variant="primary"
        onClick={downloadCSV}
      >
        <Span color="#fff">{downloadLabel || defaultLabel}</Span>
        <Span color="#fff" className="hide-mobile">
          CSV
        </Span>
      </Button>
    </span>
  )
}

export default Download
